function pad(str, length) {
    let resto = length - String(str).length;
    return '0'.repeat(resto > 0 ? resto : '0') + str;
}

export function preencherEmLote(remuneracoes, periodoInicio, periodoFim, valor = 0) {
    let periodoInicioInt = parseInt(periodoInicio.split('/')[1] + periodoInicio.split('/')[0]);
    let periodoFimInt = parseInt(periodoFim.split('/')[1] + periodoFim.split('/')[0]);

    for (let i = 0; i < remuneracoes.length; i++) {
        let split = remuneracoes[i].competencia.split('/')
        let dtRemuneracao = parseInt(split[1] + split[0], 10);
        if (dtRemuneracao >= periodoInicioInt && dtRemuneracao <= periodoFimInt) {
            remuneracoes[i].valor = valor;
            remuneracoes[i].salarioContribuicao = valor;
        }
    }
    return remuneracoes;
}

export function getTodosPeriodosEditaveis(remuneracoes) {
    let competencias = [];
    for (let i = 0; i < remuneracoes.length; i++) {
        if (remuneracaoEditavel(remuneracoes[i])) {
            competencias.push(remuneracoes[i].competencia);
        }
    }
    return competencias;
}

function getRemuneracaoPorCompetencia(remuneracoes, competencia) {
    if (!remuneracoes) return null;
    for (let i = 0; i < remuneracoes.length; i++) {
        let r = remuneracoes[i];
        if (r.competencia === competencia) {
            return r;
        }
    }
    return null;
}

export function possuiRemuneracaoZerada(remuneracoes) {
    if (!remuneracoes) return null;
    for (let i = 0; i < remuneracoes.length; i++) {
        let r = remuneracoes[i];
        if (remuneracaoEditavel(r) && r.salarioContribuicao === 0) {
            return true;
        }
    }
    return false;
}

export function possuiRemuneracaoTrabalhistaZerada(remuneracoes) {
    if (!remuneracoes) return null;
    for (let i = 0; i < remuneracoes.length; i++) {
        let r = remuneracoes[i];
        if (remuneracaoEditavel(r) && r.valor === 0) {
            return true;
        }
    }
    return false;
}

// valor de remuneracao setado em zero
export function atualizarInicioFim(remuneracoes, dtInicio, dtFim, tipoVinculo = "relacao") {
    let mes = parseInt(dtInicio.split('-')[1]);
    let ano = parseInt(dtInicio.split('-')[0]);

    let mesFim = parseInt(dtFim.split('-')[1]);
    let anoFim = parseInt(dtFim.split('-')[0]);

    let resultado = [];
    let r = null;

    while (ano <= anoFim) {
        if (ano !== anoFim) {
            while (mes <= 12) {
                r = getRemuneracaoPorCompetencia(remuneracoes, pad(mes, 2) + '/' + ano);
                if (!r) {
                    r = { competencia: pad(mes, 2) + '/' + ano, moeda: ((ano < 1994) || (ano === 1994 && mes < 7)) ? '' : 'R$' };
                    if (tipoVinculo === 'relacao') {
                        r.valor = 0;
                    } else if (tipoVinculo === 'recolhimento') {
                        r.salarioContribuicao = 0;
                        r.csNaturezaOcupacao = "URBANO";
                    }
                }
                resultado.push(r);
                mes++;
            }
            mes = 1;
        } else {
            while (mes <= mesFim) {
                r = getRemuneracaoPorCompetencia(remuneracoes, pad(mes, 2) + '/' + ano);
                if (!r) {
                    r = { competencia: pad(mes, 2) + '/' + ano, moeda: ((ano < 1994) || (ano === 1994 && mes < 7)) ? '' : 'R$' };
                    if (tipoVinculo === 'relacao') {
                        r.valor = 0;
                    } else if (tipoVinculo === 'recolhimento') {
                        r.salarioContribuicao = 0;
                        r.csNaturezaOcupacao = "URBANO";
                    }
                }
                resultado.push(r);
                mes++;
            }
        }
        ano++;
    }
    return resultado;
}

export function remuneracaoEditavel(remuneracao) {
    if (remuneracao && remuneracao.competencia) {
        let ano = remuneracao.competencia.split('/')[1];
        let mes = remuneracao.competencia.split('/')[0];

        return (ano > 1994) || (parseInt(ano) === 1994 && mes >= 7);
    }
    return false;
}

export function remuneracoesPorAno(remuneracoes) {
    if (!remuneracoes || remuneracoes === [] || remuneracoes.length === 0) return [[]];
    let remuneracoesPorAno = [[]];
    let anoCorrente = parseInt(remuneracoes[0].competencia.split('/')[1]);

    for (let i = 0; i < remuneracoes.length; i++) {
        let anoCompetencia = parseInt(remuneracoes[i].competencia.split('/')[1]);
        if (anoCompetencia !== anoCorrente) {
            remuneracoesPorAno.push([]);
            anoCorrente = anoCompetencia;
        }
        remuneracoesPorAno[remuneracoesPorAno.length - 1].unshift(remuneracoes[i]);
    }
    return remuneracoesPorAno.reverse();
}

export function validarIntervaloLote(periodoInicial, periodoFinal) {
    let inicioValor = parseInt(periodoInicial.split('/')[1] + periodoInicial.split('/')[0])
    let fimValor = parseInt(periodoFinal.split('/')[1] + periodoFinal.split('/')[0])

    return fimValor >= inicioValor;
}

export function validarDataInicial(dataInicio, dataFim, dataNascimento) {
    dataInicio = new Date(dataInicio);
    dataFim = new Date(dataFim);
    dataNascimento = new Date(dataNascimento);

    if (dataInicio < dataNascimento) {
        return "Data inicial não pode ser anterior ao nascimento."
    }
    if (dataInicio > dataFim) {
        return "Data inicial não pode ser posterior à final"
    }

    return false;
}

export function montarJsonNovoVinculo(dataInicio, dataFim, remuneracoes) {
    return {
        sequencia: -1,
        csTipoFiliado: "EMPREGADO",
        indicadores: "",
        dataInicio: dataInicio,
        dataFim: dataFim,
        relacaoTrabalhistaTO: {
            empregadorTO: {
                "codigoEmpregador": 1,
                "nomeEmpregador": "Período Adicionado Manualmente",
                "dataInicioAtividades": dataInicio,
                "dataEncerramentoAtividades": dataFim
            },
            "extemporaneo": false,
            "listaRegimesPrevidenciariosTO": [
                {
                    "csRegimePrevidenciario": "RGPS",
                    "dataInicio": dataInicio,
                    "dataFim": dataFim
                }
            ],
            "listaPeriodosOcupacoesTO": [
                {
                    "dataInicio": dataInicio,
                    "dataFim": dataFim,
                    "csNaturezaOcupacao": "URBANO"
                }
            ],
            "listaRemuneracoesTO": remuneracoes ?
                remuneracoes :
                atualizarInicioFim([], dataInicio, dataFim),
            "tipoRelacaoTrabalhista": "Empregado"
        },
        "listaPendenciasTO": [],
        "listaIndicadoresTO": []
    };
}